import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import Modal from '@material-ui/core/Modal';
import GroupTableHeadGroup from '../../components/molecules/GroupTableHeadGroup';
import GroupTableBodyGroup from '../../components/molecules/GroupTableBodyGroup';
import IdentityRegister from './IdentityRegister';
import { getIdentities } from '../../actions/Identity';
import { addUnRelationShop, getShops } from '../../actions/Shop';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ContentDialog from '../../components/molecules/ContentDialog';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    // maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset,
      limit: state.shops.limit
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          addUnRelationShop,
          getShops,
          getIdentities
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openUnRelationConfirm', 'updateOpenUnRelationConfirm', false),
  withState('openUnRelationCaution', 'updateOpenUnRelationCaution', false),
  withState('openUnRelationProgress', 'updateOpenUnRelationProgress', false),
  withState('isUnRelationSuccess', 'updateIsUnRelationSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopUnRelationParams', 'setShopUnRelationParams', null),
  withState('rowsPerPage', 'setRowsPerPage', 20),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'shopId'),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirectOpen: props => path => {
      // window.open(path, '_blank');
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    groupId,
    page,
    selectedPage,
    totalCount,
    // limit,
    // offset,
    // handleChangePage,
    // onChangePage,
    shops,
    rowsPerPage,
    openRegisterModal,
    updateOpenRegisterModal,
    order,
    orderBy,
    targetRowId,
    setTargetRowId,
    handleRedirectOpen,
    // handleChangeRowsPerPage,
    handleRequestSort,
    openUnRelationConfirm,
    updateOpenUnRelationConfirm,
    openUnRelationCaution,
    updateOpenUnRelationCaution,
    openUnRelationProgress,
    updateOpenUnRelationProgress,
    progress,
    isUnRelationSuccess,
    updateIsUnRelationSuccess,
    resultMessage,
    setResultMessage,
    shopName,
    setShopName,
    shopUnRelationParams,
    setShopUnRelationParams
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const shopRedirectAction = shopId =>
      handleRedirectOpen(`/shops_group?shopId=${shopId}`);
    const menuRedirectAction = shopId =>
      handleRedirectOpen(`/gochi_menus_group?shopId=${shopId}`);

    const stripeRegisterAlertAction = () =>
      alert('Stripe情報を先にご登録ください。');
    const identiryRegisterOpenAction = async shopId => {
      console.log('SHOPID: ', shopId);
      await actions.getIdentities({ shopId }).then(data => {
        checkSession(data);
        updateOpenRegisterModal(true);
        setTargetRowId(
          data.payload.identities &&
            data.payload.identities[0] &&
            data.payload.identities[0].identityId
            ? data.payload.identities[0].identityId
            : null
        );
      });
    };
    const identityRegisteredAlertAction = () =>
      alert('事務局で確認中です。しばらくお待ちください。');
    const identityConfirmedAlertAction = () => alert('本人確認終了済みです。');

    const identityAction = {
      stripeRegisterAlertAction,
      identiryRegisterOpenAction,
      identityRegisteredAlertAction,
      identityConfirmedAlertAction
    };

    const shopUnRelationAction = onClickParams => {
      setShopUnRelationParams(onClickParams);
      setShopName(onClickParams.shopName);
      if (onClickParams.stripeUseSwitchable) {
        updateOpenUnRelationConfirm(true);
      } else {
        updateOpenUnRelationCaution(true);
      }
    };

    const shopUnRelationOkAction = async () => {
      progress.updateLoading(true);
      updateOpenUnRelationProgress(true);
      const unRelationShop = await actions
        .addUnRelationShop(groupId, shopUnRelationParams.shopId)
        .then(addData => checkSession(addData));
      if (unRelationShop.type === 'DELETE_RELATION_SHOP_SUCCESS') {
        updateIsUnRelationSuccess(true);
        if (roles.isSecretariat) {
          const searchKey = {
            groupId,
            page: selectedPage,
            limit: rowsPerPage
          };
          actions.getShops(searchKey);
        } else if (roles.isGroup) {
          const searchKey = {
            page: selectedPage,
            limit: rowsPerPage
          };
          actions.getShops(searchKey);
        }
        setResultMessage('店舗紐付け解除が完了しました。');
        progress.updateLoading(false);
      } else {
        updateIsUnRelationSuccess(false);
        setResultMessage('店舗紐付け解除に失敗しました。');
        progress.updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isUnRelationSuccess) {
        updateOpenUnRelationConfirm(false);
        updateOpenUnRelationProgress(false);
      } else {
        updateOpenUnRelationProgress(false);
      }
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GroupTableHeadGroup
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <GroupTableBodyGroup
              shops={shops}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              shopRedirectAction={shopRedirectAction}
              menuRedirectAction={menuRedirectAction}
              identityAction={identityAction}
              shopUnRelationAction={shopUnRelationAction}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <Modal open={openRegisterModal}>
          <IdentityRegister
            updateOpenRegisterModal={updateOpenRegisterModal}
            targetRowId={targetRowId}
          />
        </Modal>
        <ConfirmDialog
          openConfirm={openUnRelationConfirm}
          updateOpenConfirm={updateOpenUnRelationConfirm}
          okAction={shopUnRelationOkAction}
          message={`「${shopName}」をグループから紐付け解除します。よろしいですか？`}
        />
        <ProgressDialog
          openProgress={openUnRelationProgress}
          progressOkAction={progressOkAction}
          loading={progress.loading}
          resultMessage={resultMessage}
        />
        <ContentDialog
          openContent={openUnRelationCaution}
          updateOpenContent={updateOpenUnRelationCaution}
          content="『自社で入金管理する』を選択した店舗をグループに紐付けた場合、グループ紐付の解除は当月内にはできません。 support@gochimeshi.com までお問い合わせください。"
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
